import { useState } from "react";
import { useUser } from "../context/user";
import { supabase } from "../supabase";
import "../styles/account.css";

function Account({ onClose }) {
  const user = useUser();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage({ type: "error", text: "New passwords do not match" });
      return;
    }

    if (newPassword.length < 8) {
      setMessage({
        type: "error",
        text: "New password must be at least 8 characters long",
      });
      return;
    }

    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      // Verify old password by attempting to sign in
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email: user.current.email,
        password: oldPassword,
      });

      if (signInError) {
        throw new Error("Current password is incorrect");
      }

      // Update password
      const { error: updateError } = await supabase.auth.updateUser({
        password: newPassword,
      });

      if (updateError) throw updateError;

      setMessage({ type: "success", text: "Password updated successfully!" });
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Password update error:", error);
      setMessage({
        type: "error",
        text:
          error.message ||
          "Failed to update password. Please check your old password.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="booth-account">
      {onClose && (
        <button
          type="button"
          className="booth-link-underline booth-account-back"
          onClick={onClose}
        >
          ← Back
        </button>
      )}

      <section className="booth-account-section">
        <h2 className="booth-account-heading">Account information</h2>
        <div className="booth-field">
          <span className="booth-field-label">Email</span>
          <p className="booth-account-readonly">{user.current?.email || ""}</p>
        </div>
        <div className="booth-field">
          <span className="booth-field-label">Name</span>
          <p className="booth-account-readonly">
            {user.current?.name || "Not set"}
          </p>
        </div>
      </section>

      <section className="booth-account-section">
        <h2 className="booth-account-heading">Change password</h2>

        {message.text && (
          <p
            className={`booth-account-message booth-account-message--${message.type}`}
          >
            {message.text}
          </p>
        )}

        <form onSubmit={handlePasswordChange} className="booth-account-form" noValidate>
          <label className="booth-field">
            <span className="booth-field-label">Current password</span>
            <input
              type="password"
              className="booth-field-input"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
          </label>
          <label className="booth-field">
            <span className="booth-field-label">New password</span>
            <input
              type="password"
              className="booth-field-input"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <span className="booth-field-hint">
              Must be at least 8 characters long
            </span>
          </label>
          <label className="booth-field">
            <span className="booth-field-label">Confirm new password</span>
            <input
              type="password"
              className="booth-field-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </label>
          <button
            type="submit"
            className="booth-btn booth-btn--primary"
            disabled={loading}
          >
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>
      </section>
    </div>
  );
}

export default Account;
